export const environment = {
    production: false,
    apikey: '9mODUr4QcFbWxxowDux8g6ZFk6BweomFwydl76B3pTBNzN3mt44buIvX',
    youtubeapikey: 'AIzaSyCR7BvZO5A3HRKXBFjdPqYpiVCjQQNUWa8',

    firebase: {
        apiKey: "AIzaSyApeSOHmOwCYYotlffP-2mulhEYLlVfI2A",
        authDomain: "lofi-radio-d03a7.firebaseapp.com",
        projectId: "lofi-radio-d03a7",
        storageBucket: "lofi-radio-d03a7.firebasestorage.app",
        messagingSenderId: "685703087009",
        appId: "1:685703087009:web:337f634d4690e9178401e0"
    }
};
